const defaultLabel = "It";
export const minName = 3;
export const maxName = 20;
export const minDescription = 3;
export const maxDescription = 80;
export const minMobile = 8;
export const maxMobile = 20;
export const minEmail = 3;
export const maxEmail = 70;
export const minPassword = 8;
export const maxPassword = 20;

export const regexPatterns = {
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*[@#!$%^&+=])(?=.*[0-9]).*$/,
  mobile: /^[0-9]+$/,
  twoDecimal: /^\d*(\.\d{0,2})?$/,
  numeric: /^[0-9\b]+$/,
  numericWithSecial: /^[\d*()+\-_]+$/,
  phone: /^\d{4} \d{3} \d{3}$/,
  mobilevalidation: /^[0-9]{10}$/,
  whitespace:
    /^[A-Za-z0-9@#.!$%^&+=_-]+(?:\s*[^A-Za-z0-9@#.!$%^&+=_-]+\s*[A-Za-z0-9@#.!$%^&+=_-]+)*$/,
  noSpaceRegex: /^\S*$/,
  firstName: /^[A-Za-z][A-Za-z\s]*$/,
  lastName: /^[A-Za-z][A-Za-z\s]*$/,
  email: /^(?:\b\S+@\S+\.\S+\b(?:[,\s]*)?)+$/,
  multiEmail: /^([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,},?){1,5}$/,
  multipleNumber: /^(?:\d+,)*\d+$/,
  singleNumber: /^([^,]*),?$/,
  phoneNumberValidation: /^(0|1)\d{2,10}$/,
  prefixValidation: /^(0|1)[0-9]{1,10}/,
};

export const validations = {
  required: {
    text: (field = defaultLabel) => {
      return { required: true, message: `${field} is required.` };
    },
    select: (field = defaultLabel) => {
      return { required: true, message: `Please select ${field}.` };
    },
  },
  min: {
    text: (min = 3, field = defaultLabel) => {
      return {
        min,
        message: `${field} should contain minimum ${min} characters.`,
      };
    },
    select: (field = defaultLabel, min: number) => {
      return {
        min,
        message: `Please select minimum ${min} ${field}.`,
      };
    },
    number: (min: number, field = defaultLabel) => {
      return {
        min,
        message: `${field} should contain minimum ${min} digits.`,
      };
    },
  },
  max: {
    text: (max = 20, field = defaultLabel) => {
      return {
        max,
        message: `${field} should contain maximum ${max} characters.`,
      };
    },
    select: (field = defaultLabel, max: number) => {
      return {
        max,
        message: `Please select maximum ${max} ${field}.`,
      };
    },
    number: (max: number, field = defaultLabel) => {
      return {
        max,
        message: `${field} should contain maximum ${max} digits.`,
      };
    },
  },
  pattern: {
    whitespace: {
      pattern: regexPatterns.whitespace,
      message: "Whitespace is not allowed.",
    },
    noSpace: {
      pattern: regexPatterns.noSpaceRegex,
      message: "Whitespace is not allowed.",
    },
    firstName: {
      pattern: regexPatterns.firstName,
      message: "First letter must be capital",
    },
    lastName: {
      pattern: regexPatterns.lastName,
      message: "First letter must be capital",
    },
    phone: {
      pattern: regexPatterns.mobilevalidation,
      message: "Phone should contain only 10 numbers.",
    },
    prefix: {
      pattern: regexPatterns.prefixValidation,
      message:
        "You must provide a numeric value starting with 0 or 1, followed by up to 10 digits.",
    },
    password: (field = defaultLabel) => {
      return {
        pattern: regexPatterns.password,
        message: `${field} should contain at least an uppercase letter, a lowercase letter, a number, and a special character.`,
      };
    },
    numeric: {
      pattern: regexPatterns.numeric,
      message: "Please enter digits only.",
    },
    numericWithSecial: {
      pattern: regexPatterns.numericWithSecial,
      message: "Please enter digits only.",
    },
    multiplenumber: {
      pattern: regexPatterns.multipleNumber,
      message: "Please enter only numbers separated by commas",
    },
    singlenumber: {
      pattern: regexPatterns.singleNumber,
      message: "the string must contain a single comma with no value after it.",
    },
    phoneNumberValidation: {
      pattern: regexPatterns.phoneNumberValidation,
      message:
        "Phone number must start with 0 or 1 and be 3 to 11 digits long.",
    },
    decimal: (number: number) => {
      return {
        pattern: regexPatterns.twoDecimal,
        message: `Please enter digits or decimal digits up to ${number} decimal places only.`,
      };
    },
    other: (field = defaultLabel) => {
      return {
        pattern: regexPatterns.firstName,
        message: `Please enter a valid ${field}.`,
      };
    },
    email: (field = defaultLabel) => {
      return {
        pattern: regexPatterns.email,
        message: `${field} Is Invalid email.`,
      };
    },
    multiEmail: (field = defaultLabel) => {
      return {
        pattern: regexPatterns.multiEmail,
        message: `${field} Is Invalid email.`,
      };
    },
  },
  email: (field = defaultLabel) => {
    return {
      type: "email",
      message: `${field} Is Invalid email.`,
    };
  },
  custom: {
    yearRange: (field = defaultLabel) => ({
      validator(_, value) {
        if (!value) return Promise.resolve();

        const year = parseInt(value, 10);
        if (year < 2023 || year > 2123) {
          return Promise.reject(
            new Error(`${field} must be between 2023 and 2123.`)
          );
        }
        return Promise.resolve();
      },
    }),
    minYear: (field = defaultLabel) => ({
      validator(_, value) {
        if (!value) return Promise.resolve();

        const year = parseInt(value, 10);
        if (year < 2023) {
          return Promise.reject(
            new Error(`${field} must be greater than 2023.`)
          );
        }
        return Promise.resolve();
      },
    }),
    monthRange: (field = defaultLabel) => ({
      validator(_, value) {
        if (!value) return Promise.resolve();

        const month = parseInt(value, 10);
        if (month < 1 || month > 12) {
          return Promise.reject(
            new Error(`${field} must be between 1 and 12.`)
          );
        }
        return Promise.resolve();
      },
    }),
  },
};
